// extracted by css-extract-rspack-plugin
export default {"content":"GridLayoutWrapper_content__YFxqo"};